export const origenesEncuesta = {
    reclamoTarjeta: 'reclamo-tarjeta',
    cambioFormaPago: 'cambio-forma-pago',
};
